<script>
  import { Form, isDev, imgSrc } from '$client';
  export let data;
  export let img;

  if (isDev() && !data)
    data = {
      header: 'Заявка на сотрудничество',
      description:
        'Если вы хотите предложить участие в социальных проектах или создать совместный проект, направляйте свои предложения нам, и мы найдем самое оптимальное решение для Вас.',
      button: 'Отправить ',
      fields: [
        {
          id: 3,
          __component: 'fields.tekst',
          placeholder: 'ФИО',
          description: null,
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'small',
          required: true,
          key: 'name',
        },
        {
          id: 2,
          __component: 'fields.telefon',
          required: true,
          description: null,
          key: 'phone',
        },
        {
          id: 1,
          __component: 'fields.vybor',
          placeholder: 'Город',
          type: 'input',
          description: null,
          required: true,
          key: 'city',
          options: [
            {
              id: 1,
              header: 'Москва',
            },
            {
              id: 2,
              header: 'Санкт-Петербург',
            },
            {
              id: 3,
              header: 'Другой город',
            },
          ],
        },
        {
          id: 4,
          __component: 'fields.tekst',
          placeholder: 'Гос. Номер',
          description: null,
          pattern: null,
          type: 'small',
          required: true,
          key: 'text',
        },
        {
          id: 1,
          __component: 'fields.fajly',
          placeholder: 'Прикрепить паспорт (фото)',
          description: null,
          type: 'many',
          required: true,
          key: 'passport',
        },
        {
          id: 2,
          __component: 'fields.fajly',
          placeholder: 'Прикрепить водительское удостоверение (фото)',
          description: null,
          type: 'single',
          required: true,
          key: 'license',
        },
        {
          id: 3,
          __component: 'fields.fajly',
          placeholder: 'Прикрепить фото автомобиля',
          description: null,
          type: 'single',
          required: true,
          key: 'carPhoto',
        },
      ],
    };
</script>

<section class="container partner-form" id="form">
  <div>
    <Form {data} />
    {#if img.caption && img.caption.includes('http')}
      <a target="_blank" rel="nofollow" href={img.caption}>
        <img loading="lazy" src={imgSrc(img.url)} alt={img.alternativeText} width="630" height="457" />
      </a>
    {:else}
      <img loading="lazy" src={imgSrc(img.url)} alt={img.alternativeText} width="630" height="457" />
    {/if}
  </div>
</section>

<style lang="scss">
  section {
    width: 100%;

    @media only screen and (max-width: 1199.98px) {
      gap: 50px;
    }

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      gap: 40px;

      :global(form) {
        width: 100% !important;
      }
    }

    div {
      position: relative;
      display: inline-flex;
      gap: 100px;
      align-items: flex-start;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-block: 50px;
      background-color: #22eaac;
      border-radius: 15px;
      padding-inline: 20px;

      @media only screen and (max-width: 991.98px) {
        display: block;
      }
    }

    :global(> a) {
      display: contents;

      @media only screen and (max-width: 991.98px) {
        display: none;
      }
    }

    img {
      object-fit: contain;

      @media only screen and (max-width: 1199.98px) {
        width: 450px;
        height: 350px;
      }

      @media only screen and (max-width: 991.98px) {
        display: none;
      }
    }
  }

  .partner-form div {
    :global(form) {
      width: 100%;
    }

    :global(form > p:first-of-type) {
      font-size: 20px;
    }

    :global(form > p) {
      margin-bottom: 30px;
      color: rgb(44 51 60 / 85%);
      font-weight: bold;
      font-size: 14px;
      font-family: Roboto;
      line-height: 1.3em;
    }

    :global(form > div) {
      display: grid !important;
      gap: 15px;

      @media only screen and (max-width: 767.98px) {
        grid-template-columns: 1fr;
      }
    }

    :global(> form > h2) {
      margin-bottom: 30px;
      font-weight: 800;
      font-family: Vela Sans;

      @media only screen and (max-width: 767.98px) {
        font-size: 24px;
      }
    }

    :global(> form > button) {
      width: 100%;
      padding: 18px 40px;
      color: #fff;
      background: rgb(44 51 60 / 100%);
      border-radius: 5px;
    }
  }
</style>
